<ng-container *ngIf="product$ | async as product">
  <div class="container">
    <h2>{{ 'productDetails.specification' | cxTranslate }}</h2>
    <table *ngFor="let class of product?.classifications">
      <th>
        <h3>{{ class.name }}</h3>
      </th>
      <tr *ngFor="let feature of class.features">
        <td>{{ feature.name }}</td>
        <td>
          <ul>
            <li *ngFor="let featureValue of feature?.featureValues">
              {{ featureValue?.value }}
              <span
                *ngIf="
                  feature.featureUnit?.symbol?.length > 0 &&
                  feature.featureUnit.unitType != '300'
                "
              >
                {{ feature.featureUnit.symbol }}
              </span>
            </li>
          </ul>
        </td>
      </tr>
    </table>
  </div>
</ng-container>
